import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(static)/trademark-disputes/case/[case]/TrademarkDisputeCasePage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
